import React from "react";

function ChartsIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      fill="none"
      viewBox="0 0 24 25"
    >
      <path
        stroke="#393D63"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M17 9.5l-3.044 4.566a1 1 0 01-1.727-.107l-.458-.918a1 1 0 00-1.727-.107L7 17.5"
      ></path>
      <rect
        width="18"
        height="18"
        x="3"
        y="3.5"
        stroke="#393D63"
        strokeWidth="2"
        rx="2"
      ></rect>
    </svg>
  );
}

export default ChartsIcon;